/** Storage file context. One of either storagePath or fileUrl must be set. */
export interface DownloadFileCtx {
  storagePath: string | null;
  fileUrl: string | null;
  location: string;
  estateId: string;
  /** Conversation containing a chat attachment. Omit for older clients and other file types. */
  conversationId?: string;
  /** Message containing the attachment; requires conversationId. */
  messageId?: string;
}

export enum FileLocation {
  DEFECTS = 'defects',
  NEWS_IMAGE = 'static/news/image',
  POLL = 'static/poll',
  MESSAGES = 'static/messages/$eId/images',
  COMPANY_LOGO = 'static/company/themes/logo'
}
